import React, { useEffect, useState } from "react";
import { getMedias } from "../../../../services/media.service";
import _ from "lodash";
import {
  DeleteOutlined,
  EditOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import EditMedia from "./EditMedia";

import parseMediaUrl from "../../functions/parseMediaUrl";
import MediaDescriptionRender from "./MediaDescriptionRender";
import {
  deleteMediaByUuid,
  getGlobalMatchdays,
} from "../../../../services/backend/api.service";
import { Button, notification, Pagination } from "antd";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "../../../../stores/globalBackendStore";
import {
  DndContext,
  DragOverlay,
  closestCorners,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { arrayMove, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import { ContainerInput } from "./ContainerSlide";
import { Item } from "./Item";
import EditPlayerData from "./EditPlayerData";

const LIMIT = 8;
const defaultAnnouncements = {
  onDragStart(id) {
    console.log(`Picked up draggable item ${id}.`);
  },
  onDragOver(id, overId) {
    if (overId) {
      console.log(
        `Draggable item ${id} was moved over droppable area ${overId}.`,
      );
      return;
    }

    console.log(`Draggable item ${id} is no longer over a droppable area.`);
  },
  onDragEnd(id, overId) {
    if (overId) {
      console.log(
        `Draggable item ${id} was dropped over droppable area ${overId}`,
      );
      return;
    }

    console.log(`Draggable item ${id} was dropped.`);
  },
  onDragCancel(id) {
    console.log(`Dragging was cancelled. Draggable item ${id} was dropped.`);
  },
};

export default (props) => {
  const { t } = useTranslation();
  const apiSetup = useGlobalStore((state) => state.apiSetup);
  const [refreshData, setRefreshData] = useState(false);
  const {
    onSelect,
    visibleEdit,
    setVisibleEdit,
    editData,
    setEditData,
    handleRemovePlayer,
    inputs,
    onOrderChange,
    openEditSlideItem,
    visibleInputEdit,
    setVisibleInputEdit,
    editInputData,
    setEditInputData,
    feedType,
    onSlideItemChange,
  } = props;
  const [activeId, setActiveId] = useState();
  const [activeItem, setActiveItem] = useState();
  const [images, setImages] = useState([]);

  const [visibleNewInput, setVisibleNewInput] = useState(false);

  const handleSelection = (e, item) => {
    props.onSelect(e, item);
  };

  const handleDelete = async (e, item) => {
    await deleteMediaByUuid({
      uuid: item.uuid,
    }).catch((err) => {
      notification["warning"]({
        message: t("Warning"),
        description: t("Media removing problem: ") + err.message,
        placement: "topRight",
      });
    });

    notification["success"]({
      message: t("Success"),
      description: t("Media has been deleted."),
      placement: "topRight",
    });
  };

  const openEdit = (e, item) => {
    setEditData(item);
    setVisibleEdit(true);
  };

  const openEditSlide = (e, item) => {
    setEditInputData(item);
    setVisibleInputEdit(true);
  };

  const [items, setItems] = useState(inputs);

  useEffect(() => {
    setItems(inputs);
  }, [inputs]);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  const handleAddNewPlayer = () => {
    setVisibleNewInput(true);
  };

  const handleOnSaveNew = (player) => {
    onSelect(player);
  };

  return (
    <>
      <div className={"top-players-list"}>
        {visibleInputEdit && (
          <EditPlayerData
            visibleEdit={visibleInputEdit}
            setVisibleEdit={setVisibleInputEdit}
            editData={editInputData}
            setEditData={setEditInputData}
            setRefreshData={setRefreshData}
            accept={_.get(apiSetup, `mediaLibrary.accept.image`)}
            feedType={feedType}
            onPlayerItemChange={onSlideItemChange}
          />
        )}
        {visibleNewInput && (
          <EditPlayerData
            visibleEdit={visibleNewInput}
            setVisibleEdit={setVisibleNewInput}
            editData={editInputData}
            setEditData={setEditInputData}
            setRefreshData={setRefreshData}
            accept={_.get(apiSetup, `mediaLibrary.accept.image`)}
            onNew={handleOnSaveNew}
          />
        )}
        <Button
          onClick={handleAddNewPlayer}
          type="primary"
          style={{ marginBottom: 16 }}
        >
          Add a new player
        </Button>
        <div className="top-players-list-container">
          <DndContext
            announcements={defaultAnnouncements}
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragStart={handleDragStart}
            onDragOver={handleDragOver}
            onDragEnd={handleDragEnd}
          >
            <ContainerInput
              items={items || []}
              handleRemovePlayer={handleRemovePlayer}
              openEditSlide={openEditSlide}
              feedType={feedType}
            />
            <DragOverlay style={{ opacity: 0.9 }}>
              {activeId ? (
                <div className={"drag-overlay-element"}>
                  <Item item={activeItem} id={activeId} />
                </div>
              ) : null}
            </DragOverlay>
          </DndContext>
        </div>
      </div>
    </>
  );

  function findContainer(id) {
    const typeId = "uuid";
    const foundElement = _.find(items, { [typeId]: id });
    return foundElement ? id : null;
  }

  function handleDragStart(event) {
    const { active } = event;
    const { id } = active;
    const typeId = "uuid";
    const currentItem = _.find(items, { [typeId]: id });
    setActiveId(id);
    setActiveItem(currentItem);
  }

  function handleDragOver({ active, over }) {
    return;
  }

  function handleDragEnd(event) {
    const { active, over } = event;
    if (!over) return;
    const { id } = active;
    const { id: overId } = over;
    const typeId = "uuid";

    const activeContainer = findContainer(id);
    const overContainer = findContainer(overId);

    if (!activeContainer || !overContainer) {
      return;
    }

    const activeIndex = _.findIndex(items, {
      [typeId]: active.id,
    });
    const overIndex = _.findIndex(items, {
      [typeId]: overId,
    });
    if (activeIndex !== overIndex) {
      //
      const originItems = [...items];
      const newItems = arrayMove(originItems, activeIndex, overIndex);
      setItems(newItems);
      onOrderChange(newItems);
    }

    setActiveId(null);
    setActiveItem(null);
  }
};
